import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HomeService } from 'app/main/admin/home/home.service';
import { PoliciesService } from 'app/main/admin/politica-de-compliance/politica-de-compliance.service';

@Component({
  selector: 'app-buttonsEdit',
  templateUrl: './buttonsEdit.component.html',
  styleUrls: ['./buttonsEdit.component.scss'],
})
export class ButtonsEditComponent implements OnInit {
  @Output() cliqueFunction = new EventEmitter();
  imagChoice: any;
  @Input() idiconRecebido: any;
  idIconChoice: any;
  list: Array<any>;

  teste = false;
  constructor(
    public dataImage: PoliciesService,
    public homeService: HomeService
  ) {}

  ngOnInit() {
    this.update();
  }
  click(event, id: number, image: string) {
    this.idIconChoice = id;
    this.imagChoice = image;
    this.cliqueFunction.emit({ id_icon: id });
  }
  update() {
    for (let i of this.imagemButton) {
      if (i.idIcon == this.idiconRecebido) {
        this.imagChoice = i.image;
        this.idIconChoice = this.idiconRecebido;
      } else {
        // this.ChoiceButtonStandard()
      }
    }
  }

  imagemButton = [
    {
      image: '../assets/images/imagensButtons/martelo.svg',
      idIcon: 1,
    },
    {
      image: 'assets/images/imagensButtons/fotoDoc.svg',
      idIcon: 2,
    },
    {
      image: '../assets/images/imagensButtons/balanca.svg',
      idIcon: 3,
    },
    {
      image: '../assets/images/imagensButtons/pastaDeArquivos.svg',
      idIcon: 4,
    },
    {
      image: '../assets/images/imagensButtons/som.svg',
      idIcon: 5,
    },
    {
      image: '../assets/images/imagensButtons/phone.svg',
      idIcon: 6,
    },
    {
      image: '../assets/images/imagensButtons/visualizar.svg',
      idIcon: 7,
    },
    {
      image: '../assets/images/imagensButtons/genero.svg',
      idIcon: 8,
    },
    {
      image: '../assets/images/imagensButtons/config.svg',
      idIcon: 9,
    },
    {
      image: '../assets/images/imagensButtons/arroba.svg',
      idIcon: 10,
    },
    {
      image: '../assets/images/imagensButtons/cavalo.svg',
      idIcon: 11,
    },
    {
      image: '../assets/images/imagensButtons/telefone.svg',
      idIcon: 12,
    },
    {
      image: '../assets/images/imagensButtons/direcao.svg',
      idIcon: 13,
    },
    {
      image: '../assets/images/imagensButtons/internet.svg',
      idIcon: 14,
    },
  ];
}

